import React from 'react';

import { PreviewTemplateModal } from './preview-template-modal.component';
import { isBandedTemplate } from '../../../lib/helpers/format-template.helpers';
import { useFormatTemplateStages } from '../use-format-template-stages';

interface IPreviewTemplateModalGraphQLProps {
  open: boolean;
  onClose: () => void;
  template: IFormatTemplate | null;
}

export const PreviewTemplateModalGraphQL: React.FC<IPreviewTemplateModalGraphQLProps> = ({ open, onClose, template }) => {
  // A banded template renders its band summary and no stage list, so the drill / practice-plan /
  // position lookups that list needs would be fetched and thrown away.
  const { stages, drillOptions, practicePlanOptions, positionOptions, loading } = useFormatTemplateStages(
    template,
    open && !isBandedTemplate(template),
  );

  return (
    <PreviewTemplateModal
      open={open}
      onClose={onClose}
      template={template}
      stages={stages}
      drillOptions={drillOptions}
      practicePlanOptions={practicePlanOptions}
      positionOptions={positionOptions}
      loading={loading}
    />
  );
};
